import React, { useState } from 'react'
import classes from './App.module.css';
import { Route, BrowserRouter as Router, Switch } from 'react-router-dom'
import About from './pages/About'
import Manual from './pages/Manual'
import MainApp from './pages/MainApp'
import Home from './pages/Home'

function App() {
  const [showSettings, setShowSettings] = useState(false)
  const [sound, setSound] = useState(true)

  const onClose = () => showSettings ? setShowSettings(false) : setShowSettings(true)
  const soundOnOff = () => {
    if (sound) {
      console.log('sound OFF')
      setSound(false)
    } else {
      console.log('sound ON')
      setSound(true)
    }
  }

  return (
    <Router>
      <div className={classes.app} style={{ height: window.innerHeight }}>
        <Switch>
          <Route path="/" exact >
            <Home onClose={onClose} showSettings={showSettings} sound={sound} soundOnOff={soundOnOff} />
          </Route>
          <Route path='/about' exact>
            <About onClose={onClose} showSettings={showSettings} sound={sound} soundOnOff={soundOnOff} />
          </Route>
          <Route path='/app' exact>
            <MainApp onClose={onClose} showSettings={showSettings} sound={sound} soundOnOff={soundOnOff} />
          </Route>
          <Route path="/manual">
            <Manual onClose={onClose} showSettings={showSettings} sound={sound} soundOnOff={soundOnOff} />
          </Route>
        </Switch>
      </div>
    </Router>
  );
}

export default App;
